var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44 21.32l1.792-8.456h5.628l.504-2.408h-5.628l1.288-6.02h7.252L20.78 2H10.112c-.896 0-1.68.275-2.352.826-.672.55-1.11 1.283-1.316 2.198L3 21.32h6.44z",
    fill: "#C5F6EE",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFancy);
export default __webpack_public_path__ + "static/media/fancy.fee47eb628b56f5f1185d0fc1a6204b7.svg";
export { ForwardRef as ReactComponent };